























































































































































import "./member-setup.less";
import Vue from "vue";
import { mapState, mapGetters } from "vuex";
import UserAvatar from "../../components/common/user-avatar.vue";
import Modal from "../../components/common/confirm.js";

export default Vue.extend({
  name: "member-setup",
  components: { UserAvatar },
  props: {
    member: Object,
    showSetup: Boolean,
  },
  data() {
    return {
      listMode: false,
      currentPage: "members",
      currentMember: null,
      changingRoleByUser: true,
      currentMemberOriginalRole: null,
      rules: {
        role: [
          {
            required: true,
            message: "Please choose permission",
            trigger: "blur",
          },
        ],
      },
      sending: false,
      inviteModel: {
        memberId: null,
        role: null,
      },
      inviteFormRules: {
        memberId: [
          {
            type: "number",
            required: true,
            message: "Please select a user",
            trigger: "blur",
          },
        ],
        role: [
          {
            type: "number",
            required: true,
            message: "Please select a role",
            trigger: "blur",
          },
        ],
      },
    };
  },
  computed: {
    ...mapState("project", ["currentProject"]),
    ...mapState("billing", ["billingAccount"]),
    ...mapGetters("project", ["currentProjectInviteRoles", "getRoleDetails", "memberRoleTitle", "roleTitle"]),
    showModal: {
      get: function () {
        return (this as any).showSetup;
      },
      set: function (newValue) {
        (this as any).$emit("cancel");
      },
    },
    teams() {
      let project = (this as any).$store.state.project.currentProject;
      return project && project.teams ? project.teams : [];
    },
    allMembers() {
      let project = (this as any).$store.state.project.currentProject;
      let members = project && project.members ? project.members : [];
      if (members === null) {
        members = [];
      }

      return members.map((member, index) => {
        return {
          memberId: member.memberId,
          memberName: member.memberName,
          memberEmailAddress: member.memberEmailAddress,
          memberPhoneNumber: member.memberPhoneNumber,
          memberAvatarImageUrl: member.memberAvatarImageUrl,
          role: member.role,
          isOwner: member.isOwner,
          reinvite: member.accepted === false,
        };
      });
    },
    authorAndMembers() {
      let allMembers = this.allMembers;

      if (allMembers && allMembers.length > 0) {
        return allMembers.filter((member) => member.role == 6);
      } else {
        return [];
      }
    },
    guestMembers() {
      let allMembers = this.allMembers;
      if (allMembers && allMembers.length > 0) {
        return allMembers.filter((member) => member.role == 4);
      } else {
        return [];
      }
    },
    pageTitle() {
      if (this.currentPage == "members") {
        return "Project Role Assignments";
      } else if (this.currentPage == "member") {
        return "User";
      } else if (this.currentPage == "invite") {
        return "Invite";
      } else if (this.currentPage == "remove") {
        return "Remove User?";
      } else {
        return "";
      }
    },
    showPageTitle() {
      return !(!this.listMode && this.currentPage == "member");
    },
    showBackButton() {
      return !((!this.listMode && this.currentPage == "member") || (this.listMode && this.currentPage == "members"));
    },
    accountUsers() {
      let context = this as any;
      let members = context.billingAccount && context.billingAccount.members ? context.billingAccount.members.filter((m) => m.licenseAssigned === true) : [];
      if (context.currentProject && context.currentProject.members) {
        members = members.filter((m) => context.currentProject.members.filter((member) => member.memberId === m.memberId).length === 0);
      }

      return members;
    },
  },
  watch: {
    showModal(newVal) {
      if (newVal === true) {
        this.listMode = this.member ? false : true;
        this.currentPage = "members";
        if (this.member) {
          this.assignCurrentMember(this.member);
          this.currentPage = "member";
        }
      }
    },
  },
  mounted() {
    this.loadAccountInfo();
  },
  methods: {
    loadAccountInfo() {
      this.$store
        .dispatch("billing/getBillingAccountInfo")
        .then((response) => {})
        .finally(() => {});
    },
    handleSendInvite() {
      let context = this;
      event.preventDefault();
      let target = (event.target as any).closest("button") as HTMLButtonElement;
      target.disabled = true;
      context.sending = true;

      let projectId = context.$store.state.project.currentProject.id;

      let form = context.$refs.InviteForm as any;
      form.validate((valid: boolean) => {
        if (valid) {
          context.$store
            .dispatch("project/inviteMember", {
              data: {
                memberId: context.inviteModel.memberId,
                role: context.inviteModel.role,
                beOwner: false,
                projectId: projectId,
              },
            })
            .then((response) => {
              context.$store.dispatch("project/get", {
                id: projectId,
              });
              context.currentPage = "members";
            })
            .finally(() => {
              context.sending = false;
              target.disabled = false;
            });
        } else {
          target.disabled = false;
          context.sending = false;
        }
      });
    },
    showInviteUser() {
      this.inviteModel.memberId = null;
      this.inviteModel.role = null;

      this.currentPage = "invite";
    },
    assignCurrentMember(member) {
      this.changingRoleByUser = false;
      this.currentMember = Object.assign({}, member);
      this.currentMemberOriginalRole = member.role;
      this.changingRoleByUser = true;
    },
    handleChangeRole(role) {
      let context = this;
      if (context.changingRoleByUser) {
        context.updateMemberRole(role);
      }
    },
    updateMemberRole(role) {
      let context = this;
      let projectId = context.$store.state.project.currentProject.id;

      let data = {
        email: context.currentMember.memberEmailAddress,
        role: role,
        projectId: projectId,
        memberId: context.currentMember.memberId,
      };

      this.$store
        .dispatch("project/updateMember", {
          data: data,
        })
        .then((response) => {
          context.$store.dispatch("project/get", {
            id: projectId,
          });
          context.currentMemberOriginalRole = role;
          context.currentMember.role = role;
        })
        .catch((error) => {
          context.changingRoleByUser = false;
          context.currentMember.role = context.currentMemberOriginalRole;
          context.changingRoleByUser = true;
        });
    },
    handleRemove() {
      let context = this;
      let projectId = context.$store.state.project.currentProject.id;
      let target = (event.target as any).closest("button") as HTMLButtonElement;
      target.disabled = true;

      let data = {
        email: context.currentMember.memberEmailAddress,
        projectId: projectId,
      };
      if (context.currentMember.memberId) {
        (data as any).memberId = context.currentMember.memberId;
      }

      let popupContent = "<p>You are about to move this user's access to the project. Do you want to proceed?</p>";
      Modal.confirm({
        title: "Remove User From Project?",
        content: popupContent,
        okText: "Proceed with user removal",
        cancelText: "Never mind",
        onOk: () => {
          context.removeMember(data, () => {
            target.disabled = false;
          });
        },
        onCancel: () => {
          target.disabled = false;
        },
      });
    },
    removeMember(removeInput, callback) {
      let context = this;
      context.$store
        .dispatch("project/removeMember", {
          data: removeInput,
        })
        .then((response) => {
          context.$store.dispatch("project/get", {
            id: removeInput.projectId,
          });
          context.$emit("cancel");
        })
        .finally(() => {
          if (callback) {
            callback();
          }
        });
    },
    handleMemberClick(member) {
      this.currentPage = "member";
      this.assignCurrentMember(member);
    },
    handleBackClick() {
      if (this.currentPage == "member" || this.currentPage == "invite") {
        this.currentPage = "members";
      } else {
        this.currentPage = "member";
      }
    },
  },
});
